// extracted by mini-css-extract-plugin
export default {"wrapper":"DHQ5NTKsfWu8zL2r5MUn","titleContainer":"aJ2MyLYVR9osD8RP3MS5"};